import { Spinner } from "reactstrap";

function FetchLoadingIndicator() {
	return (
		<div className="dis-vet-center flex-column justify-content-center py-100 text-center ">
			{/*<h4 className="f-16 fw-600">در حال بارگذاری اطلاعات صبور باشید...</h4>*/}
			<Spinner type="grow" color="primary" />
		</div>
	);
}

export default FetchLoadingIndicator;
